import { useNavigate, useOutletContext, useParams } from "react-router-dom";
import { Button } from "../components/atoms";
import {
    EMPTY_EMPLOYMENT_TYPE_FORM_STATE,
    type EmploymentTypeFormOutletContext,
} from "../components/EmploymentTypeEditLayout";
import {
    ContractInfoFormSection,
    type ContractInfoFormValue,
} from "../components/ContractInfoFormSection";

/**
 * 雇用形態 - 契約情報設定ページ（Step 2）
 *
 * UI 本体は ContractInfoFormSection（従業員側と共有）に委譲する。
 * このページは pendingFormState との値の橋渡しとフッターボタンのみを担う。
 */
const EmploymentTypeWorkRuleFormPage = () => {
    const navigate = useNavigate();
    const { id } = useParams<{ id?: string }>();
    const isEdit = !!id;
    const {
        pendingFormState,
        setPendingFormState,
    } = useOutletContext<EmploymentTypeFormOutletContext>();

    const baseState = pendingFormState ?? EMPTY_EMPLOYMENT_TYPE_FORM_STATE;
    // EmploymentTypeFormState は ContractInfoFormValue を構造的に内包する
    const contractInfoValue: ContractInfoFormValue = baseState;

    const handleContractInfoChange = (next: ContractInfoFormValue) => {
        setPendingFormState({
            ...baseState,
            ...next,
        });
    };

    const handleBack = () => {
        navigate(isEdit ? `/tenant/employment-type/${id}/edit` : "/tenant/employment-type/new");
    };

    const handleCancel = () => {
        navigate("/tenant/employment-type");
    };

    const handleNext = () => {
        navigate(isEdit ? `/tenant/employment-type/${id}/tags` : "/tenant/employment-type/new/tags");
    };

    return (
        <div className="flex-1 flex flex-col bg-white rounded-lg overflow-hidden">
            <div className="flex-1 overflow-auto p-6">
                <ContractInfoFormSection
                    value={contractInfoValue}
                    onChange={handleContractInfoChange}
                    showWeekdayRules={false}
                />
            </div>

            <div className="flex justify-end gap-4 px-6 py-4">
                <Button variant="primary" size="md" onClick={handleBack} className="px-8">
                    1.基本情報の設定に戻る
                </Button>
                <Button variant="outline" size="md" onClick={handleCancel} className="px-8">
                    キャンセル
                </Button>
                <Button variant="primary" size="md" onClick={handleNext} className="px-8">
                    3.タグの設定へ進む
                </Button>
            </div>
        </div>
    );
};

export default EmploymentTypeWorkRuleFormPage;
